
import axios from 'axios';
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardHeader, MDBCol, MDBLightbox, MDBLightboxItem, MDBRow, MDBTabs, MDBTabsItem, MDBTabsLink,MDBSmoothScroll,MDBSpinner,MDBCardFooter,
  MDBBtn,MDBContainer
} from 'mdb-react-ui-kit';
import { fetchCompanyMap, fetchData, fetchDocumentMap} from './../utils/Common';
import EntityDetailModal from '../entity/EntityDetailModal';
import PropTypes from 'prop-types';
import React, {useEffect, useContext, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { UserProfileContext } from '../context/UserProfileProvider';
import { MiscContext } from '../context/MiscProvider';
const MultiView = ({setIsReceiptToBeViewed, companyFromModal, setShowAlertForProcessed}) => {
    const { companiesMap,setCompaniesMap ,setDocumentsMap,isUploading, setIsUploading} = useContext(MiscContext);
    const {tokenLoaded} = useContext(UserProfileContext);
    const sectionFiveRef = useRef(null);
    const containerFourRef = useRef(null);
    const [viewItem, setViewItem] = useState(null);
    const [isSecondModalOpen, setIsSecondModalOpen] = useState(false);
    const {key} = useParams();
   const selectedCompany = Array.isArray(companiesMap) ? companiesMap.find(company => company.name === key || company.name === companyFromModal) : null;


    const [activeTab, setActiveTab] = useState(selectedCompany?.receipts && selectedCompany?.receipts[0] && selectedCompany?.receipts[0].receiptPurchaseDate);
    const [activeReceipt, setActiveReceipt] = useState(selectedCompany?.receipts?.find(receipt => receipt.receiptPurchaseDate === activeTab));

    const handleTabChange = (type) => {
        setActiveTab(type);
        setActiveReceipt(selectedCompany?.receipts?.find(receipt => receipt.receiptPurchaseDate === type));
      }
//const [isLoading, setIsLoading] = useState(false);
    const baseUrl = process.env.REACT_APP_INVENTORY_URL;
    
    
    const resetImageStatus = async (receiptId,companyId) => {
      try {
          // Set loading state to true before deleting receipt
          setIsUploading(true);
  
          // Make API call to delete receipt
          const endpoint = `${baseUrl}/imgs/initial/${receiptId}/company/${companyId}`;
          const response = await axios.put(endpoint, {
              withCredentials: true,
          });
  
          if (response.status === 200) {
              console.log('Receipt deleted successfully');
  
              // Update state to remove deleted receipt
              setCompaniesMap(prevCompany => {
                  // Filter out the deleted receipt
                  const updatedReceipts = prevCompany?.receipts?.filter(receipt => receipt.id !== receiptId);
                  
                  // If the deleted receipt was active, update the activeTab state
                  const newActiveTab = updatedReceipts?.length > 0 ? updatedReceipts[0].receiptPurchaseDate : null;
  
                  return {
                      ...prevCompany,
                      receipts: updatedReceipts,
                      activeTab: newActiveTab,
                  };
              });
              setIsReceiptToBeViewed(false);
              setShowAlertForProcessed(true);
          
if (tokenLoaded) {
 
  await fetchDocumentMap(setDocumentsMap,tokenLoaded);
  await fetchCompanyMap(setCompaniesMap,tokenLoaded);
}
          } else {
              console.error(`Error: ${response.status}`);
          }
      } catch (err) {
          console.error('An error occurred while deleting receipt:', err);
      } finally {
          // Set loading state to false after deleting receipt
          setIsUploading(false);
      }
  };
  




  useEffect(() => {
    if (selectedCompany?.receipts?.length > 0) {
        // Create a map to count occurrences of receiptPurchaseDates
        const receiptDatesCount = selectedCompany.receipts.reduce((acc, receipt) => {
            const date = receipt.receiptPurchaseDate;
            acc[date] = acc[date] ? acc[date] + 1 : 1;
            return acc;
        }, {});

        // Iterate through receipts and suffix duplicate dates
        selectedCompany.receipts.forEach(receipt => {
            const date = receipt.receiptPurchaseDate;
            const count = receiptDatesCount[date];
            if (count > 1) {
                let suffix = 1;
                let suffixedDate = `${date}_${suffix}`;
                while (receiptDatesCount[suffixedDate]) {
                    suffix++;
                    suffixedDate = `${date}_${suffix}`;
                }
                receipt.receiptPurchaseDate = suffixedDate;
                receiptDatesCount[suffixedDate] = 1;
            }
        });

        // Set active tab and receipt
        setActiveTab(selectedCompany.receipts[0].receiptPurchaseDate);
        setActiveReceipt(selectedCompany.receipts.find(receipt => receipt.receiptPurchaseDate === selectedCompany.receipts[0].receiptPurchaseDate));
    }
}, []);


useEffect(() => {
    if (selectedCompany?.receipts?.length > 0) {
        setActiveReceipt(selectedCompany?.receipts?.find(receipt => receipt.receiptPurchaseDate === activeTab));
    }
}, []);

return (
  <MDBContainer className="mb-2 position-relative grainy-gradient-intro justify-content-center text-center">
   {isUploading &&
              <MDBSpinner className='mx-2' color='warning'>
                <span className='visually-hidden'>Loading...</span>
              </MDBSpinner>}
    {isSecondModalOpen && <EntityDetailModal isSecondModalOpen={isSecondModalOpen} setIsSecondModalOpen={setIsSecondModalOpen} viewItem={viewItem} setViewItem={setViewItem}/>}
    <MDBCard className='text-center'>
  <MDBCardHeader>
    <MDBTabs pills className='card-header-tabs'>
      {selectedCompany?.receipts?.map((receipt, index) => (
        <MDBTabsItem key={index}>
     
          <MDBTabsLink active={activeTab === receipt?.receiptPurchaseDate} onClick={() => handleTabChange(receipt?.receiptPurchaseDate)}>
            {receipt.receiptPurchaseDate}
          </MDBTabsLink>
        </MDBTabsItem>
      ))}
    </MDBTabs>
  </MDBCardHeader>
  <MDBCardBody className='justify-content-center'>
 
  <MDBRow className="border d-flex align-items-center justify-content-center" >
          <MDBCol md='3 mt-2 mb-2' style={{ overflowY: 'auto', height: '800px',  textAlign: 'center' }}>
            <MDBSmoothScroll
              targetRef={sectionFiveRef}
              containerRef={containerFourRef}
              duration={1000}
              easing={(t) => {
                t /= 0.5;
                if (t < 1) return 0.5 * t * t * t * t;
                t -= 2;
                return -(t * t * t * t - 2) / 2;
              }}
            >
              <MDBLightbox>
                <MDBLightboxItem
                  style={{ width: '100%' }}
                  zoomLevel={0.25}
                  src={activeReceipt?.receiptUrl}
                  fullscreenSrc={activeReceipt?.receiptUrl}
                  className="rounded"
                />
              </MDBLightbox>
            </MDBSmoothScroll>
          </MDBCol>
          <MDBCol md='3'>
           
           
              <MDBCard>
                <MDBCardHeader><MDBCardTitle>Line Items</MDBCardTitle></MDBCardHeader>
                <MDBCardBody>
                {activeReceipt?.entities?.map((entity, entityIndex) => (
                  <MDBCard key={entityIndex} className='mb-2'>
                    <MDBRow>
                      <MDBCol md="8"> {/* Column for entity name */}
                        {entity?.name}
                      </MDBCol>
                      <MDBCol md="4" className="text-right">
                        <MDBBtn size='sm' tag='a' color='none' className='m-1' style={{ color: '#dd4b39' }} onClick={() => {
                          setIsSecondModalOpen(true);
                          setViewItem(entity);
                        }}>
                          Detailed
                        </MDBBtn>
                      </MDBCol>
                    </MDBRow>
                  </MDBCard>
                ))}
</MDBCardBody>
<MDBCardFooter>
                <MDBBtn size='sm' tag='a' className='m-1' disabled={!activeReceipt?.id || !selectedCompany?.id} onClick={() => {
            resetImageStatus(activeReceipt?.id, selectedCompany?.id);
          }}>
            Process Again
          </MDBBtn>
          </MDBCardFooter>
              </MDBCard>
           
          </MDBCol>
          
        </MDBRow>
</MDBCardBody>


</MDBCard>

  </MDBContainer>
);

}
MultiView.propTypes = {
  setIsReceiptToBeViewed: PropTypes.func,
  setShowAlertForProcessed: PropTypes.func,
  companyFromModal: PropTypes.string,
}

export default MultiView;